module.exports = __webpack_public_path__ + "img/uncle.be5030ca.webp";